<template lang="pug">
  div(:class="themeClass")
    header.header(:class="{ hide: this.headerHidden }")
      div.header-wrap
        button.drawer-toggle(@click="toggleDrawler")
          span MENU
        div.header-logo
          router-link(:to="{ name: 'SearchJob' }")
            img(:src="siteLogo()" :alt="siteName()")
        div.drawer(:class="{ open: openDrawer }")
          a.drawer-close(@click="toggleDrawler") 閉じる
          PrivatePageHeaderUserName
          div.header-menu-left
            ul
              li(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'SearchJob' }",
                  class="button-list"
                  :class="{ active: this.path === '/search/job' || this.path === '/search/grouping-job' }"
                  @click.native="toggleDrawler"
                ) 求人検索
              li(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'SearchMap' }",
                  class="button-map"
                  :class="{ active: this.path === '/search/map' }"
                  @click.native="toggleDrawler"
                ) MAP検索
              li(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'SearchCompany' }",
                  class="button-search"
                  :class="{ active: this.path === '/search/company' }"
                  @click.native="toggleDrawler"
                ) 事業所検索
              li(v-if="isCorporationPage()")
                router-link(
                  :to="{ name: 'SearchCorporation' }",
                  class="button-search"
                  :class="{ active: this.path === '/search/corporation' }"
                  @click.native="toggleDrawler"
                ) 法人検索
              li(v-if="user.has_starting_business")
                router-link(
                  :to="{ name: 'SearchStartingBusiness' }",
                  class="button-search"
                  :class="{ active: this.path === '/search/starting_business' }"
                  @click.native="toggleDrawler"
                ) 開業情報
              li(v-if="user.display_aggregations && !this.spMode")
                router-link(
                  :to="{ name: 'AggregateJob' }",
                  class="button-aggregation"
                  :class="{ active: this.path === '/aggregate/job' }"
                  @click.native="toggleDrawler"
                ) 市況分析
              li(v-if="user.lead_management")
                a(:href="lmtUrl()" class="button-lmt" target="_blank") 営業管理
              li(v-if="user.has_basic && !this.spMode")
                a.button-guide(@click="showGuide") 活用ガイド
              li(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'News' }"
                  class="button-news"
                  :class="{ active: this.path === '/news', 'has-new-news': hasRecentNews }"
                  @click.native="toggleDrawler"
                  )
                  span.news-link-label News
                  span.news-new-badge(v-if="hasRecentNews") NEW
          div.header-menu-right
            ul
              li.mylist(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'JobList' }",
                  @click.native="toggleDrawler"
                ) 求人リスト
              li.mysearch(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'SearchConditions' }",
                  @click.native="toggleDrawler"
                ) 求人検索管理
              li.mysearch(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'ExclusionCompanyName' }",
                  @click.native="toggleDrawler"
                ) 除外企業管理
              li.mysearch(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'InclusionCompanyName' }",
                  @click.native="toggleDrawler"
                ) 登録企業管理
              li.mylist(v-if="user.has_basic")
                router-link(
                  :to="{ name: 'CompanyList' }",
                  @click.native="toggleDrawler"
                ) 事業所リスト
              li.mylist(v-if="user.has_starting_business")
                router-link(
                  :to="{ name: 'StartingBusinessList' }",
                  @click.native="toggleDrawler"
                ) 開業情報リスト
          div.header-logout
            a(v-if="!logouting" @click.prevent="signOut") ログアウト
            a.disabled(v-else) ログアウト中
        div.drawer-cover(@click="toggleDrawler")

      MessageToast

    router-view

    CommonModal
    GuideModal
    JobGuideModal
    JobListGuideModal
    HakenGuideModal
    CompanyGuideModal
    MapGuideModal
    AggregtionJobGuideModal
    JobAiManuscriptModal
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { ErrorMessages } from '../constants'
  import CommonModal from './parts/CommonModal'
  import GuideModal from './parts/GuideModal'
  import JobGuideModal from './parts/JobGuideModal'
  import JobListGuideModal from './parts/JobListGuideModal'
  import HakenGuideModal from './parts/HakenGuideModal'
  import CompanyGuideModal from './parts/CompanyGuideModal'
  import MapGuideModal from './parts/MapGuideModal'
  import AggregtionJobGuideModal from './parts/AggregtionJobGuideModal'
  import MessageToast from './parts/MessageToast'
  import PrivatePageHeaderUserName from './parts/PrivatePageHeaderUserName'
  import JobAiManuscriptModal from './parts/JobAiManuscriptModal'

  export default {
    components: {
      CommonModal,
      PrivatePageHeaderUserName,
      MessageToast,
      GuideModal,
      JobGuideModal,
      JobListGuideModal,
      HakenGuideModal,
      CompanyGuideModal,
      MapGuideModal,
      AggregtionJobGuideModal,
      JobAiManuscriptModal,
    },
    data () {
      return {
        openDrawer: false,
        headerHidden: false,
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.detail,
        client: state => state.client.detail,
        meta: state => state.route.meta,
      }),
      ...mapGetters({
        logouting: 'session/logouting',
        spMode: 'common/spMode',
        hasRecentNews: 'news/hasRecentNews',
      }),
      path () {
        return this.$route.path
      },
      themeClass () {
        if (location.hostname.includes('mynavi')) return 'theme-mynavi'
      },
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
      this.fetchRecentNewsStatus()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        if (this.spMode && this.meta.scrollHiddenHeaderSP) {
          this.headerHidden = (window.scrollY > 60)
        } else {
          this.headerHidden = false
        }
      },
      toggleDrawler () {
        if (this.spMode) {
          this.openDrawer = !this.openDrawer
        }
      },
      async signOut () {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('session/signOut')
          this.$router.push({ name: 'SignIn' })
        } catch (e) {
          if (e.some(errorMessage => errorMessage.message === ErrorMessages.NO_AUTHORIZATION)) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.$store.dispatch('common/pushToastError', { error: e })
          }
          this.$store.commit('common/unlockGlobal')
        }
      },
      lmtUrl () {
        if (location.origin.match(/kobot/)) {
          return location.origin.replace('kobot', 'lmt-kobot')
        }
        return location.origin.replace('app', 'lmt')
      },
      showGuide () {
        this.$store.commit('guide/showModal')
      },
      async fetchRecentNewsStatus () {
        if (!this.user.has_basic) return

        try {
          if (!this.client.id) await this.$store.dispatch('client/fetch')

          const oemIdentifier = this.client && this.client.oem_partner_identifier
          await this.$store.dispatch('news/fetchRecent', { oemIdentifier })
        } catch (e) {
          this.$store.commit('news/setHasRecentNews', false)
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/PrivatePage.vue